import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import { makeClassStubIfUnknown, makeDemoValue } from "../../demoValues";

class IncorrectVariableDeclaration extends React.Component {

  render() {
    const demoArray = makeDemoValue(`${this.props.typeName}[]`, true);
    const classPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.typeName)}</div>;

    return <CompilerError
      title={<>Expecting DOT, found <div className="InputValue">'{this.props.foundName}'</div></>}
      translation="You are trying to use an array which has been declared incorrectly."
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      <Problem
        title="You may have made a syntax error while declaring the array."
      >
        <Suggestion title="Add the word 'new' beside the type variable you are declaring.">
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = {this.props.typeName}[5]; </div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}[5]; </div>
          </GoodExample>
        </Suggestion>
        <Suggestion title={"Add a semicolon \";\" at the end of declaration."}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}[5] </div>
          </BadExample>

          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = {demoArray} </div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}[5]; </div>
          </GoodExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = {demoArray}; </div>
          </GoodExample>
        </Suggestion>
        <Suggestion title={"Add an equal sign \"=\" when declaring."}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} new {this.props.typeName}[5]; </div>
          </BadExample>

          <BadExample>
            {classPlaceholder}
            <div className="Indent-0">
              {this.props.typeName}[] {this.props.foundName} {demoArray};
            </div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}[5]; </div>
          </GoodExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = {demoArray}; </div>
          </GoodExample>
        </Suggestion>
        <Suggestion title="Specify the size of the array.">
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}; </div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0"> {this.props.typeName}[] {this.props.foundName} = new {this.props.typeName}[5]; </div>
          </GoodExample>
        </Suggestion>
      </Problem>
    </CompilerError>;
  }
}

export default IncorrectVariableDeclaration;
